var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.valueIsObj)?_c('b-input',{model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}}):_c('b-input',{attrs:{"value":_vm.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c5cb16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/Input.vue
// module id = s4QH
// module chunks = 1